import { Component, OnChanges, ChangeDetectionStrategy, Inject } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Environment } from '../../models/environment.model';
import { AccessControlService } from '../../services/access-control.service';

interface NavVisibility {
  reportedUsers: boolean;
  bannedUsers: boolean;
  underReviewUsers: boolean;
  silentHiddenUsers: boolean;
  suspiciousUsers: boolean;
  messageFlags: boolean;
  blockAllow: boolean;
  matches: boolean;
  prompts: boolean;
  algorithm: boolean;
  verifications: boolean;
  analytics: boolean;
  tools: boolean;
}

@Component({
  standalone: false,
  selector: 'sa-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavComponent implements OnChanges {
  readonly adminTitle: string;

  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  /** Which nav links are visible for the current admin (all visible when unrestricted). */
  readonly nav$: Observable<NavVisibility> = this.access.allowedPaths$.pipe(
    map(allowedPaths => ({
      reportedUsers: this.access.isAllowed(allowedPaths, '/reported-users'),
      bannedUsers: this.access.isAllowed(allowedPaths, '/banned-users'),
      underReviewUsers: this.access.isAllowed(allowedPaths, '/under-review-users'),
      silentHiddenUsers: this.access.isAllowed(allowedPaths, '/silent-hidden-users'),
      suspiciousUsers: this.access.isAllowed(allowedPaths, '/suspicious-users'),
      messageFlags: this.access.isAllowed(allowedPaths, '/message-flags'),
      blockAllow: this.access.isAllowed(allowedPaths, '/block-allow'),
      matches: this.access.isAllowed(allowedPaths, '/matches'),
      prompts: this.access.isAllowed(allowedPaths, '/prompts'),
      algorithm: this.access.isAllowed(allowedPaths, '/algorithm'),
      verifications: this.access.isAllowed(allowedPaths, '/verifications'),
      analytics: this.access.isAllowed(allowedPaths, '/analytics'),
      tools: this.access.isAllowed(allowedPaths, '/tools'),
    })),
    shareReplay(1),
  );

  constructor(
    private breakpointObserver: BreakpointObserver,
    @Inject('environment') private environment: Environment,
    protected route: ActivatedRoute,
    private access: AccessControlService,
  ) {
    this.adminTitle = this.environment.adminTitle;
  }

  ngOnChanges() {
    console.log(this.route);
  }

}
